export interface IAppConfigState {
	formDataConfigs: Object;
	systemAppConfigs: Object;
	userAppConfigs: Object;
}

export const APP_CONFIG_MODULE_TYPES = {
    GET_FORM_DATA_CONFIG_BY_TYPE: 'getFormDataConfigByType',
	UPDATE_CONFIG_VALUE: 'updateConfigValue',
	GET_SYSTEM_CONFIG: 'getSystemConfig',
    GET_USER_CONFIG: 'getUserConfig',
    SET_USER_CONFIG: 'setUserConfig',
    SET_SYSTEM_CONFIG: 'setSystemConfig'
}

export const COMMON_CONFIG_KEYS = {
	POPULAR_EMAIL_DOMAIN: 'PopularEmailDomains'
}